import styled, { css } from 'styled-components';

import Link from 'Elements/Link';

import { BackgroundColor } from './SolentStory';

export const Wrapper = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
`;

export const Container = styled.article<{ $featured: boolean }>`
    ${({ theme, $featured }) => css`
        position: relative;
        flex-grow: 1;
        overflow: ${$featured ? 'hidden' : 'visible'};
        border-radius: 0.5rem;
        width: 100%;
        display: flex;
        flex-direction: column;
        background-color: ${theme.colors.secondary.tints[12].hex};

        ${!$featured &&
        css`
            height: 100%;
        `}
    `}
`;

export const StyledLink = styled(Link)`
    &:after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        z-index: 2;
    }
`;

export const ImageWrapper = styled.div<{
    $featured: boolean;
}>`
    ${({ theme, $featured }) => css`
        position: relative;
        min-height: 12.6rem;
        z-index: 1;

        ${!$featured &&
        css`
            &:after {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background: linear-gradient(
                    to bottom,
                    transparent 80%,
                    ${theme.colors.secondary.tints[12].hex} 100%
                );
            }
        `}

        @media ${theme.breakpoints.large.media} {
            min-height: 12.5rem;

            ${$featured &&
            css`
                min-height: 17rem;
            `}
        }
    `}
`;

export const AnimatedImageWrapper = styled.div<{
    $featured: boolean;
    $hovered: boolean;
    $blur: boolean;
}>`
    ${({ theme, $featured, $hovered, $blur }) => css`
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 100%;
        border-radius: 0.5rem 0.5rem 0 0;
        overflow: hidden;
        transition: all 0.25s ease;

        @media ${theme.breakpoints.medium.media} {
            ${$hovered &&
            css`
                height: calc(100% + 2rem);
            `}

            ${$blur &&
            css`
                img {
                    transition: all 0.25s ease;

                    ${$featured &&
                    css`
                        filter: blur(0.25rem) brightness(0.3);
                    `}

                    ${!$featured &&
                    css`
                        transform: scale(1.2);
                    `}
                }
            `}
        }
    `}
`;

export const AvatarWrapper = styled.div<{
    $hovered: boolean;
    $backgroundColor: BackgroundColor;
    $featured: boolean;
}>`
    ${({ theme, $hovered, $backgroundColor, $featured }) => css`
        position: absolute;
        left: 1.4rem;
        bottom: 1.25rem;
        transform: rotate(0deg);
        width: 5.5rem;
        height: 5.5rem;
        border-radius: 50%;
        border: solid ${theme.colors.primaryContrast.hex} 0.25rem;
        overflow: hidden;
        transition: all 0.25s ease;
        background: ${$backgroundColor.primary};
        z-index: 3;

        @media ${theme.breakpoints.medium.media} {
            left: 1.25rem;
            width: 6.5rem;
            height: 6.5rem;
        }

        @media ${theme.breakpoints.large.media} {
            transform: ${$hovered ? 'rotate(0deg)' : 'rotate(-20deg)'};
            border-radius: ${$hovered ? '50%' : '0.5rem'};
            top: ${$hovered ? '-1.625rem' : '-2.625rem'};
            left: 1.25rem;
            width: 6.5rem;
            height: 6.5rem;

            ${$featured &&
            css`
                left: 2.25rem;
                width: 8rem;
                height: 8rem;
            `}
        }
    `}
`;

export const Content = styled.div<{
    $hovered: boolean;
    $backgroundColor: BackgroundColor;
    $featured: boolean;
}>`
    ${({ theme, $hovered, $backgroundColor, $featured }) => css`
        position: relative;
        display: flex;
        padding: 1rem 1.5rem 1.25rem 8rem;
        flex-direction: column;
        background-color: ${$backgroundColor.secondary};
        transition: all 0.25s ease;
        z-index: 2;
        color: ${theme.colors.text.hex};
        border-radius: 0 0 0.5rem 0.5rem;
        height: 100%;
        pointer-events: none;

        @media ${theme.breakpoints.medium.media} {
            padding: 1.25rem 1.5rem 1.25rem 9rem;
            min-height: 6.55rem;
        }

        @media ${theme.breakpoints.large.media} {
            background-color: ${$hovered
                ? $backgroundColor.secondary
                : theme.colors.secondary.tints[12].hex};
            color: ${$hovered ? theme.colors.text.hex : theme.colors.secondary.tints[1].hex};
            min-height: 7.125rem;
            padding: 1rem 1.5rem 1.625rem ${$hovered ? '10rem' : '9.5rem'};

            ${$featured &&
            css`
                padding: 1.25rem 1.5rem 1.625rem ${$hovered ? '13rem' : '12.5rem'};
            `}
        }
    `}
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        font-size: 1rem;
        font-weight: 200;
        line-height: 1.3;
        margin: 0;
        color: inherit;

        @media ${theme.breakpoints.medium.media} {
            font-size: 1.125rem;
        }

        @media ${theme.breakpoints.large.media} {
            font-size: 1.25rem;
        }
    `}
`;

export const Title = styled.p`
    ${({ theme }) =>
        css`
            margin: 0;
            font-size: 1rem;
            line-height: 1.3;
            font-weight: bold;

            /* @media ${theme.breakpoints.medium.media} {
                font-size: 1.125rem;
            }

            @media ${theme.breakpoints.large.media} {
                font-size: 1.25rem;
            } */
        `}
`;

export const Organisation = styled.p`
    ${({ theme }) =>
        css`
            margin: 0;
            font-size: 1rem;
            line-height: 1.3;
            font-weight: bold;

            /* @media ${theme.breakpoints.medium.media} {
                font-size: 1.125rem;
            }

            @media ${theme.breakpoints.large.media} {
                font-size: 1.25rem;
            } */
        `}
`;

export const Quote = styled.blockquote<{ $hovered: boolean }>`
    ${({ theme, $hovered }) => css`
        position: absolute;
        font-size: 1.8rem;
        margin: 1.5rem 1.5rem 0 13rem;
        top: ${$hovered ? '0' : '-1rem'};
        color: ${theme.colors.primaryContrast.hex};
        font-family: ${theme.fonts.secondary};
        font-weight: 100;
        line-height: 1.1;
        z-index: 2;
        opacity: ${$hovered ? '1' : '0'};
        transition: all 0.25s ease;
        display: none;

        @media ${theme.breakpoints.large.media} {
            display: block;
        }
    `}
`;

export const Featured = styled.div<{ $hovered: boolean }>`
    ${({ theme, $hovered }) => css`
        position: absolute;
        top: 1.5rem;
        left: -4.6rem;
        background: ${theme.colors.primaryContrast.hex};
        text-align: center;
        box-shadow: 0rem 0.375rem 0.375rem #000000e6;
        color: ${theme.colors.primary.hex};
        z-index: 3;
        padding: 0.25rem 5rem;
        transform: rotate(315deg);
        transition: opacity 0.25s ease;
        pointer-events: none;

        @media ${theme.breakpoints.large.media} {
            opacity: ${$hovered ? '0' : '1'};
            padding: 0.5rem 5rem;
        }
    `}
`;

export const FeaturedText = styled.span`
    color: inherit;
    font-weight: bold;
`;

export const ReadTab = styled.span<{ $hovered: boolean }>`
    ${({ theme, $hovered }) => css`
        position: absolute;
        top: -1.75rem;
        right: 0;
        font-size: 1rem;
        border-radius: 0.5rem 0rem 0rem 0rem;
        text-transform: uppercase;
        background: ${theme.colors.primaryContrast.hex};
        color: ${theme.colors.text.hex};
        padding: 0.25rem 1rem;
        transition: top 0.25s ease;
        z-index: 1;

        @media ${theme.breakpoints.large.media} {
            top: ${$hovered ? '-1.75rem' : '0'};
        }
    `}
`;

export const ContentWrapper = styled.div`
    position: relative;
    height: 100%;
    z-index: 2;
    pointer-events: none;
`;

export const Subject = styled.div`
    ${({ theme }) => css`
        font-size: 1rem;
        position: relative;
        font-weight: 100;
        left: 0;
        display: inline-block;
        color: ${theme.colors.secondary.tints[1].hex};
        background-color: ${theme.colors.secondary.tints[12].hex};
        border-radius: 0.5rem 0.5rem 0rem 0rem;
        padding: 0.25rem 0.56rem 0.3rem;
        transition: top 0.25s ease;

        ::first-letter {
            text-transform: capitalize;
        }

        ::after {
            content: '';
            position: absolute;
            bottom: -2rem;
            left: 0;
            width: 100%;
            background-color: inherit;
            height: 2rem;
        }

        @media ${theme.breakpoints.large.media} {
            height: 2rem;
        }
    `}
`;
